const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20landscape%20with%20warm%20golden%20sunset%20light%20piercing%20through%20dramatic%20storm%20clouds%2C%20lone%20figure%20silhouette%20on%20hilltop%2C%20professional%20film%20color%20grading%20with%20rich%20amber%20and%20deep%20teal%20tones%2C%20blockbuster%20movie%20atmosphere%20with%20heroic%20composition%2C%20cinematic%20anamorphic%20lens%20flare%20effect%2C%20high%20end%20film%20production%20visual%20quality&width=700&height=400&seq=media-card-c01&orientation=landscape',
    tag: '热播推荐',
    title: '暑期档重磅来袭，多部国产大片同期上线',
    desc: '动作巨制与悬疑佳片轮番登场，成全影院每日更新最新片源，让你足不出户看遍院线热门。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Intimate%20drama%20scene%20with%20soft%20warm%20candlelight%20illuminating%20two%20figures%20in%20conversation%2C%20shallow%20depth%20of%20field%20with%20beautiful%20bokeh%20background%2C%20film%20grain%20texture%20and%20subtle%20vignette%2C%20emotional%20storytelling%20atmosphere%2C%20art%20house%20cinema%20aesthetic%20with%20muted%20warm%20color%20palette%2C%20professional%20cinematography%20quality&width=700&height=400&seq=media-card-c02&orientation=landscape',
    tag: '新剧上线',
    title: '高分悬疑新剧开播，口碑爆棚引热议',
    desc: '这部烧脑悬疑剧凭借紧凑剧情和精湛演技迅速出圈，成全影院同步更新，追剧党的首选。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20dynamic%20lighting%20and%20energetic%20atmosphere%2C%20spotlights%20sweeping%20across%20performance%20area%2C%20concert%20style%20production%20design%20with%20LED%20screens%20and%20smoke%20effects%2C%20entertainment%20show%20broadcast%20quality%20visuals%2C%20lively%20crowd%20energy%20palpable%20in%20composition%2C%20professional%20television%20production%20aesthetic&width=700&height=400&seq=media-card-c03&orientation=landscape',
    tag: '热门综艺',
    title: '王牌综艺回归，笑点密集全程高能不断',
    desc: '本季综艺阵容豪华，游戏环节全新升级，成全影院当日同步更新，让你笑到停不下来。',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent-400 mb-3">HIGHLIGHTS</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">精彩推荐</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">编辑精选的近期热门影视内容，不容错过</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {mediaItems.map((item, i) => (
              <article key={i} className="group bg-background-200/60 rounded-xl overflow-hidden border border-background-200/40 hover:border-primary-500/20 transition-all duration-300">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-xs px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-14 h-14 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center border border-background-50/30">
                      <i className="ri-play-fill text-2xl text-background-50"></i>
                    </div>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors duration-200">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}